/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IBloodBank } from 'app/shared/model/blood-bank.model';
import { EntityType } from 'app/shared/model/enumerations/entity-type.model';

export interface IBloodBankAssociation {
  id?: string;
  associatedDate?: number;
  leavingDate?: number | null;
  timestampEntry?: number;
  microSec?: number;
  lastUpdated?: number;
  active?: boolean;
  cursor?: number;
  openingTime?: string | null;
  closeTime?: string | null;
  internal?: boolean | null;
  createdDtm?: number | null;
  createdBy?: string | null;
  modifiedBy?: string | null;
  leftAssociation?: boolean | null;
  entityType?: keyof typeof EntityType;
  entityId?: string;
  association?: IBloodBank;
}

export const defaultValue: Readonly<IBloodBankAssociation> = {
  active: false,
  internal: false,
  leftAssociation: false,
};
